/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay））
 * @export
 * @enum {number}
 */
export enum PaymentMethodEnum {
    /** 車内支払 */
    IN_CAR_PAYMENT = '0',
    /** アプリ支払（クレカ） */
    APP_PAYMENT_CREDIT_CARD = '1',
    /** アプリ支払（Apple Pay） */
    APP_PAYMENT_APPLE_PAY = '3',
    /** RingoPass支払 */
    RINGO_PASS_PAYMENT = '4',
    /** 後席決済（汎用QR） */
    BACK_SEAT_PAYMENT = '5',
    /** アプリ支払（CABカード） */
    APP_PAYMENT_CAB_CARD = '6',
    /** アプリ支払（S.RIDE Biz） */
    APP_PAYMENT_S_RIDE_BIZ = '7',
    /** アプリ支払（PayPay） */
    APP_PAY_PAY = '10',
    /** アプリ支払（auPay） */
    APP_AU_PAY = '11',
    /** アプリ支払（d払い） */
    APP_D_PAY = '12',
    /** アプリ支払（R Pay） */
    APP_R_PAY = '13',
    /** アプリ支払（DiDi） */
    APP_PAYMENT_DIDI = '14',
    /** アプリ支払（Uber） */
    APP_PAYMENT_UBER = '15'
}

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay）） の Union 型
 * @export
 * @typedef PaymentMethod
 */
export type PaymentMethod =
  typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay）） のラベルマップ
 * @export
 */
export const PaymentMethodLabels = {
    /**
     * 数値キー: PaymentMethodEnum.IN_CAR_PAYMENT
     * 名前キー:  IN_CAR_PAYMENT
     */
    [PaymentMethodEnum.IN_CAR_PAYMENT]: '車内支払',
    IN_CAR_PAYMENT:                             '車内支払',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_CREDIT_CARD
     * 名前キー:  APP_PAYMENT_CREDIT_CARD
     */
    [PaymentMethodEnum.APP_PAYMENT_CREDIT_CARD]: 'アプリ支払（クレカ）',
    APP_PAYMENT_CREDIT_CARD:                             'アプリ支払（クレカ）',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_APPLE_PAY
     * 名前キー:  APP_PAYMENT_APPLE_PAY
     */
    [PaymentMethodEnum.APP_PAYMENT_APPLE_PAY]: 'アプリ支払（Apple Pay）',
    APP_PAYMENT_APPLE_PAY:                             'アプリ支払（Apple Pay）',
    /**
     * 数値キー: PaymentMethodEnum.RINGO_PASS_PAYMENT
     * 名前キー:  RINGO_PASS_PAYMENT
     */
    [PaymentMethodEnum.RINGO_PASS_PAYMENT]: 'RingoPass支払',
    RINGO_PASS_PAYMENT:                             'RingoPass支払',
    /**
     * 数値キー: PaymentMethodEnum.BACK_SEAT_PAYMENT
     * 名前キー:  BACK_SEAT_PAYMENT
     */
    [PaymentMethodEnum.BACK_SEAT_PAYMENT]: '後席決済（汎用QR）',
    BACK_SEAT_PAYMENT:                             '後席決済（汎用QR）',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_CAB_CARD
     * 名前キー:  APP_PAYMENT_CAB_CARD
     */
    [PaymentMethodEnum.APP_PAYMENT_CAB_CARD]: 'アプリ支払（CABカード）',
    APP_PAYMENT_CAB_CARD:                             'アプリ支払（CABカード）',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_S_RIDE_BIZ
     * 名前キー:  APP_PAYMENT_S_RIDE_BIZ
     */
    [PaymentMethodEnum.APP_PAYMENT_S_RIDE_BIZ]: 'アプリ支払（S.RIDE Biz）',
    APP_PAYMENT_S_RIDE_BIZ:                             'アプリ支払（S.RIDE Biz）',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAY_PAY
     * 名前キー:  APP_PAY_PAY
     */
    [PaymentMethodEnum.APP_PAY_PAY]: 'アプリ支払（PayPay）',
    APP_PAY_PAY:                             'アプリ支払（PayPay）',
    /**
     * 数値キー: PaymentMethodEnum.APP_AU_PAY
     * 名前キー:  APP_AU_PAY
     */
    [PaymentMethodEnum.APP_AU_PAY]: 'アプリ支払（auPay）',
    APP_AU_PAY:                             'アプリ支払（auPay）',
    /**
     * 数値キー: PaymentMethodEnum.APP_D_PAY
     * 名前キー:  APP_D_PAY
     */
    [PaymentMethodEnum.APP_D_PAY]: 'アプリ支払（d払い）',
    APP_D_PAY:                             'アプリ支払（d払い）',
    /**
     * 数値キー: PaymentMethodEnum.APP_R_PAY
     * 名前キー:  APP_R_PAY
     */
    [PaymentMethodEnum.APP_R_PAY]: 'アプリ支払（R Pay）',
    APP_R_PAY:                             'アプリ支払（R Pay）',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_DIDI
     * 名前キー:  APP_PAYMENT_DIDI
     */
    [PaymentMethodEnum.APP_PAYMENT_DIDI]: 'アプリ支払（DiDi）',
    APP_PAYMENT_DIDI:                             'アプリ支払（DiDi）',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_UBER
     * 名前キー:  APP_PAYMENT_UBER
     */
    [PaymentMethodEnum.APP_PAYMENT_UBER]: 'アプリ支払（Uber）',
    APP_PAYMENT_UBER:                             'アプリ支払（Uber）',
} as const;

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay）） のラベル Union 型
 * @export
 * @typedef PaymentMethodLabel
 */
export type PaymentMethodLabel =
  typeof PaymentMethodLabels[keyof typeof PaymentMethodLabels];

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay）） のラベル取得関数
 * @export
 * @param { PaymentMethod } value - 列挙体の値
 * @returns { PaymentMethodLabel } ラベル文字列
 */
export function getPaymentMethodLabel(
  value: PaymentMethod
): PaymentMethodLabel {
  return PaymentMethodLabels[value];
}

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay）） のラベル配列を取得する関数
 * @export
 * @param { PaymentMethod[] } values - 列挙体の値配列
 * @returns { PaymentMethodLabel[] } ラベル文字列配列
 */
export function getPaymentMethodLabels(values: PaymentMethod[]): PaymentMethodLabel[] {
  return values.map((value) => getPaymentMethodLabel(value));
}

/**
 * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）,11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay）） のラベル配列
 * @export
 */
export const PaymentMethodLabelList = [
  '車内支払','アプリ支払（クレカ）','アプリ支払（Apple Pay）','RingoPass支払','後席決済（汎用QR）','アプリ支払（CABカード）','アプリ支払（S.RIDE Biz）','アプリ支払（PayPay）','アプリ支払（auPay）','アプリ支払（d払い）','アプリ支払（R Pay）','アプリ支払（DiDi）','アプリ支払（Uber）',
] as const;

